import { useTranslations } from 'next-intl';
import { AgentLineWebsearch } from '@/app/components/icons/AgentLineWebsearch';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { useStore } from '@/app/providers/store';
import type { AgentSettings } from '@/app/types';
import { cn, reportEvent } from '@/app/utils';

export const ConnectToInternet = ({
  onSelectSearch,
  selectedSettings,
}: {
  onSelectSearch: () => void;
  selectedSettings: AgentSettings;
}) => {
  const t = useTranslations();
  const isConnectToInternet = selectedSettings?.net_mode === 'search';
  const { agentProjectDetail } = useStore((state) => ({
    agentProjectDetail: state.agentProjectDetail,
  }));

  return (
    <CustomTooltip
      content={t('agentProject.internetSearch.tip')}
      side="top"
      sideOffset={4}
      disableHoverableContent={true}
      variant="glass"
    >
      <div
        className={cn(
          'relative flex h-8 cursor-pointer items-center justify-between rounded-full border border-system-white12 bg-system-white04 p-2 text-system-white transition-colors hover:border-system-white64 hover:bg-system-white24',
          isConnectToInternet && 'border-[#4D6DFF]',
        )}
        onClick={() => {
          onSelectSearch();
          if (!isConnectToInternet) {
            reportEvent('dialog_internet_deselected', {
              project_id: agentProjectDetail?.id || '',
            });
          }
        }}
      >
        <AgentLineWebsearch className={cn('size-4', isConnectToInternet && 'text-[#4D6DFF]')} />
        {!isConnectToInternet && (
          <div className="-top-2 -right-4 absolute rounded-4 bg-[#0086FF] px-1 py-0 font-normal text-[10px]">New</div>
        )}
      </div>
    </CustomTooltip>
  );
};
